<template>
  <!-- 首页 -->
  <div class="homePage">
    <!-- 顶部背景图 -->
    <div class="homePage-top"></div>
    <!-- 数据中台 -->
    <div class="DataZhongt">
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div1-2-1">
            <div>
              NO.1
              <ul>
                <li>垂直行业领先的</li>
                <li>科技服务平台</li>
              </ul>
            </div>
            <div style="border-left: 2px solid #dddddd; border-right: 2px solid #dddddd">
              <span>10 <span>年</span> </span>
              <ul>
                <li>丰富的行业经验</li>
                <li>和技术沉淀</li>
              </ul>
            </div>
            <div style="border-right: 2px solid #dddddd">
              40⁺
              <ul>
                <li>专业财税服务专家</li>
              </ul>
            </div>
            <div>
              1000⁺
              <ul>
                <li>产业商户</li>
                <li>小微个体户</li>
                <li>产业企业等</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div>
    <!-- 为产业生态企业提供平台支持 -->
    <div class="platform-zc">
      <p class="Title">为产业生态企业提供平台支持</p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div-flex">
            <div class="flex-word">
              <h3 class="h3-one">
                <span>产业个人/个体户</span>
              </h3>
              <div>
                <p><span> •</span>【服务方案】</p>
                <p>
                  通过平台优势为产业个人商户、个体户、小微企业提供快捷的贸易系统及配套的税筹服务、物流服务，通过电子商务的手段，解决产业个人商户、个体户、小微企业在商贸流通环节的服务难题。
                </p>
              </div>
              <div>
                <p><span> •</span>【服务价值】</p>
                <p>
                  面向产业个人商户、个体户、小微企业提供超低税率及商贸发展引导资金的支持，配备专属的税务筹划专家；打造专属H5网络宣传页面，享受海量站内外曝光机会；提供专业的商贸服务系统。
                </p>
              </div>
            </div>
            <div class="flex-img">
              <img src="../../assets/homePage/ptzc-large-one.png" alt="" />
            </div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div-flex">
            <div class="flex-img">
              <img src="../../assets/homePage/ptzc-large-two.png" alt="" />
            </div>
            <div class="flex-word">
              <h3 class="h3-two">
                <span>工厂/贸易商</span>
              </h3>
              <div>
                <p><span> •</span>【服务方案】</p>
                <p>
                  提供供应链平台化协同服务，以及产品化的供应链金融服务，实现业务数据线上化，交付过程可视化，强化线上优势，实现业务跨区域发展。
                </p>
              </div>
              <div>
                <p><span> •</span>【服务价值】</p>
                <p>
                  入驻数字产业集聚区，快速获取税收优惠政策扶持，帮助企业享区域性税收奖励；享受更优质的专属供应链服务；专享平台提供的智慧物流服务，一键掌握货物实时状态。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div-flex">
            <div class="flex-word">
              <h3 class="h3-three">
                <span>供应链公司</span>
              </h3>
              <div>
                <p><span> •</span>【服务方案】</p>
                <p>
                  快速搭建专属供应链服务平台，通过平台化、SaaS化的方式将平台提供给供应链公司，进行场景创新，帮助供应链公司快速实现化管标准理。
                </p>
              </div>
              <div>
                <p><span> •</span>【服务价值】</p>
                <p>
                  帮助供应链公司高效搭建流量变现场景，合规解决资金困难、支付结算等问题，降低企业成本，丰富金融场景。
                </p>
              </div>
            </div>
            <div class="flex-img">
              <img src="../../assets/homePage/ptzc-large-three.png" alt="" />
            </div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div-flex">
            <div class="flex-img">
              <img src="../../assets/homePage/ptzc-large-four.png" alt="" />
            </div>
            <div class="flex-word">
              <h3 class="h3-four">
                <span>银行等资金方</span>
              </h3>
              <div>
                <p><span> •</span>【服务方案】</p>
                <p>
                  提供优质资产清单，供应链全流程可视化端口开放，关键节点预警，随时掌握资金流向。
                </p>
              </div>
              <div>
                <p><span> •</span>【服务价值】</p>
                <p>
                  通过1N1业务穿透的创新模式，直达到资产底层，形成5大画像，帮助资金方输出风控能力，解决资金方批量获客的困扰，并产生收益。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="div0"></div>
      </div>
      <el-button type="primary" round @click="ApplicationProcess">我要入驻</el-button>
    </div>
    <!-- 物润介绍 -->
    <div class="introduce">
      <div class="div1">
        <div class="div1-0"></div>
        <div class="div1-1">
          <div style="margin-bottom: 50px">
            <p class="p1"><span></span>产融供应链</p>
            <p class="p2">
              以科技赋能供应链服务，把产业端与金融端链接起来，形成闭环供应链金融体系，构建产融数字化供应链服务生态，为中小企业开拓市场、打造品牌赋能，
              实现“创牌、创量、创利”。
            </p>
          </div>
          <div>
            <p class="p1"><span></span>产融大数据</p>
            <p class="p2">
              构建产融供应链核心数据资产，链接产业、工商、发票、税务、物流、司法、征信、舆情、环保等大数据，打通产业上下游的数据壁垒，将数据分析应用能力专业化；打造产融供应链大数据中心，构建产融大数据信息第一高频入口。
            </p>
          </div>
        </div>
        <div class="div1-2"></div>
        <div class="div1-3">
          <div style="margin-bottom: 50px">
            <p class="p1"><span></span>产融科技</p>
            <p class="p2">
              基于数字化产融平台，通过构建司机、车辆、运单、发货人及收货人5大画像、供应链1+N+1结构穿透，实现产业与金融信息的对接，实现中小微企业数据的资产化，使资产更加真实、可靠、及时。
            </p>
          </div>
          <div>
            <p class="p1"><span></span>数字产业财税服务</p>
            <p class="p2">
              以“产业财税”作为核心策略，打造供应链+网络货运平台+数字化产业财税支持体系，为企业客户、有车企业、个体司机、船东解决进项税抵扣不足的问题，为当地政府增加税收，促进当地产业转型升级和提质增效。
            </p>
          </div>
        </div>
        <div class="div1-4"></div>
      </div>
    </div>
    <!-- 平台定位 -->
    <div class="PosiTion">
      <p class="Title">平台定位</p>
      <p class="min-Title">
        物润产融供应链平台瞄准产融数字化升级需求，发展智慧物流+供应链，构建网络空间
      </p>
      <p class="min-Title">
        新型“产链融”关系整合全产业链及服务方，以i2S2B商业模式赋能产业链，实现产融供应链业务闭环
      </p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div3"></div>
        <div class="div0 div4"></div>
        <div class="div0 div5"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 物润产融供应链平台 -->
    <div class="wrcrGylpt">
      <p class="Title">物润产融供应链平台</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 平台能力 -->
    <div class="ability">
      <p class="Title">平台能力</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2">
          <div class="div1-1">
            <img src="../../assets/homePage/ptnl-lhbs.png" alt="" />
            <p>灵活部署能力</p>
          </div>
          <div class="div1-2">
            <div class="div1-2-1 div-height1">
              赋能供应链公司，通过SaaS化服务，进行平台的快速部署、功能的快速更新和拓展，并且自由组合，在短期内实现业务数字化。
            </div>
          </div>
        </div>
        <div class="div0 div3">
          <div class="div1-1">
            <img src="../../assets/homePage/ptnl-stjh.png" alt="" style="width: 54px" />
            <p>生态聚合能力</p>
          </div>
          <div class="div1-2">
            <div>
              产融数字化是时代选项，
              产融供应链平台支撑产融数字化转型。新的数字化架构能满足产业生态各方不同角色的不同应用场景的需求。
            </div>
          </div>
        </div>
        <div class="div0 div4">
          <div class="div1-1">
            <img src="../../assets/homePage/ptnl-sjfx.png" alt="" />
            <p>数据分析能力</p>
          </div>
          <div class="div1-2">
            <div>
              可视化呈现企业的关键业务和场景，通过AI运算，将大数据应用到具体业务，相比人工判断，给出更精准的方案。
            </div>
          </div>
        </div>
        <div class="div0 div5">
          <div class="div1-1">
            <img src="../../assets/homePage/ptnl-Aiot.png" alt="" />
            <p>AIoT智联能力</p>
          </div>
          <div class="div1-2">
            <div>
              基于云计算、人工智能AIoT平台，一站链接软件、硬件、数据、产品、信息，向平台用户提供安全无忧、快速成熟的解决方案。
            </div>
          </div>
        </div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 行业实践 -->
    <!-- <div class="practice">
      <p class="Title">行业实践</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2">
          <div class="div1-1">
            <img src="../../assets/homePage/hysj-rzcyjjq.png" alt="" />
            <div>
              <p>10 +</p>
              <p>入驻产业聚集区</p>
            </div>
          </div>
        </div>
        <div class="div0 div3">
          <div class="div1-1">
            <img src="../../assets/homePage/hysj-zcyh.png" alt="" />
            <div>
              <p>2000 +</p>
              <p>注册用户</p>
            </div>
          </div>
        </div>
        <div class="div0 div4">
          <div class="div1-1">
            <img src="../../assets/homePage/hysj-rjdds.png" alt="" />
            <div>
              <p>500 +</p>
              <p>日均订单数</p>
            </div>
          </div>
        </div>
        <div class="div0 div6"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {};
  },
  methods: {
    ApplicationProcess() {
      this.$router.push("/ApplicationProcess");
    },
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  text-align: center;
  position: relative;
  height: 100%;
}
.homePage-top {
  background: url("../../assets/homePage/home-banner.webp") center center no-repeat;
  height: 662px;
}
/* 数据中台开始 */
.DataZhongt {
  color: #333333;
  background: #ffffff;
  border-bottom: 20px solid #f5f7fa;
}
.DataZhongt > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
}

.DataZhongt > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.DataZhongt > .div .div1 {
  padding: 40px 20px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.DataZhongt > .div .div1 .div1-2-1 {
  width: 100%;
  display: flex;
  font-size: 16px;
  color: #373d41;
  line-height: 29px;
  div {
    width: 24%;
    font-size: 40px;
    line-height: 45px;
    padding: 10px 30px;
    span{
      position: relative;
      span{
        padding-left: 4px;
        font-weight: bold;
        position: absolute;
        font-size: 15px;
        top: -4px;
      }
    }
    p {
      margin-top: 20px;
      display: inline-block;
      background: #f3f8ff;
      padding: 10px 35px;
      font-size: 16px;
      line-height: 29px;
      border-radius: 6px;
    }
    ul {
      margin-top: 20px;
      li {
        font-size: 18px;
        line-height: 30px;
      }
    }
  }
}
// }
/* 数据中台结束 */
// 平台支持开始
.platform-zc {
  // height: 744px;
  color: #333333;
  background: #ffffff;
  padding-bottom: 50px;
}
.platform-zc > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 30px 0;
}
.platform-zc > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
}

.platform-zc > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.platform-zc > .div .div1 {
  padding: 30px 20px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  font-family: Microsoft YaHei;
  font-weight: 400;
  .div-flex {
    text-align: left;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .flex-word {
      flex: 1;
      padding-left: 10px;
      h3 {
        position: relative;
        margin: 10px 0px 0px 30px;
        width: 86px;
        height: 76px;
        span {
          width: 250px;
          position: absolute;
          // left: 30px;
          bottom: 0px;
          font-size: 24px;
        }
      }
      .h3-one {
        background: url("../../assets/homePage/ptzc-small-one.png") center center
          no-repeat;
      }
      .h3-two  {
        background: url("../../assets/homePage/ptzc-small-two.png") center center
          no-repeat;
      }
      .h3-three  {
        background: url("../../assets/homePage/ptzc-small-three.png") center center
          no-repeat;
      }
      .h3-four  {
        background: url("../../assets/homePage/ptzc-small-four.png") center center
          no-repeat;
      }
      div {
        padding: 15px 10px;
        color: #373d41;

        p:nth-child(1) {
          font-size: 18px;
          line-height: 34px;
          font-weight: bold;
          span {
            color: #2f82ffff;
            line-height: 34px;
            font-size: 28px;
          }
        }
        p:nth-child(2) {
          font-size: 16px;
          line-height: 24px;
          padding-left: 20px;
        }
      }
    }
    .flex-img {
      width: 666px;
      height: 388px;
      img {
        width: 666px;
        height: 388px;
      }
    }
  }
}

.el-button.is-round {
  margin-top: 30px;
  padding: 14px 50px;
  box-shadow: 0px 4px 15px 2px rgb(113, 167, 248);
}
// 平台支持结束
/* 物润介绍--开始 */
.introduce {
  height: 660px;
  background: url("../../assets/homePage/wr-banner.png") center center no-repeat;
}
.introduce > .div1 {
  display: flex;
  padding-top: 150px;
}

.introduce > .div1 .div1-0,
.introduce > .div1 .div1-4 {
  flex: 1;
}

.introduce > .div1 .div1-1,
.introduce > .div1 .div1-3 {
  width: 310px;
  margin-top: -80px;
}

.introduce > .div1 .div1-1 div,
.introduce > .div1 .div1-3 div {
  width: 310px;
  height: 238px;
  background: #ffffff;
  border-radius: 16px;
}

.introduce > .div1 .div1-1 div .p1,
.introduce > .div1 .div1-3 div .p1 {
  height: 50px;
  line-height: 50px;
  text-align: left;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.introduce > .div1 > .div1-1 div:nth-child(1) .p1 span {
  background: url("../../assets/homePage/wr-crgyl.png") center center no-repeat;
}
.introduce > .div1 > .div1-1 div:nth-child(2) .p1 span {
  background: url("../../assets/homePage/wr-crdsj.png") center center no-repeat;
}
.introduce > .div1 > .div1-3 div:nth-child(1) .p1 span {
  background: url("../../assets/homePage/wr-crkj.png") center center no-repeat;
}
.introduce > .div1 > .div1-3 div:nth-child(2) .p1 span {
  background: url("../../assets/homePage/wr-szcycsfw.png") center center no-repeat;
}
.introduce > .div1 .div1-1 div .p1 span,
.introduce > .div1 .div1-3 div .p1 span {
  width: 36px;
  height: 34px;
  display: inline-block;
  background-size: 100%;
  margin: 0 10px;
  vertical-align: middle;
}

.introduce > .div1 .div1-1 div .p2,
.introduce > .div1 .div1-3 div .p2 {
  text-align: left;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  padding: 0 10px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}

.introduce > .div1 .div1-2 {
  width: 410px;
  height: 338px;
  background: url("../../assets/homePage/wr-zylogoslt.png") center center no-repeat;
}
/* 物润介绍--结束 */
/* 平台定位开始 */
.PosiTion {
  height: 698px;
  background: url("../../assets/homePage/ptdw-banner.png") center center no-repeat;
}
.PosiTion > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fffefe;
  text-align: center;
  padding: 70px 0 20px 0;
}
.PosiTion > .min-Title {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #fffefe;
  line-height: 30px;
  text-align: center;
  margin-bottom: 4px;
}
.PosiTion > .div {
  display: flex;
}

.PosiTion > .div .div1,
.PosiTion > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.PosiTion > .div .div2,
.PosiTion > .div .div3,
.PosiTion > .div .div4,
.PosiTion > .div .div5 {
  margin: 30px 22px 0 22px;
  width: 272px;
  height: 379px;
  background: #ffffff;
  box-shadow: 0px 1px 36px 2px rgba(93, 93, 93, 0.13);
  display: flex;
}
.PosiTion > .div .div2 {
  background: url("../../assets/homePage/ptdw-changj.png") center center no-repeat;
}
.PosiTion > .div .div3 {
  background: url("../../assets/homePage/ptdw-kej.png") center center no-repeat;
}
.PosiTion > .div .div4 {
  background: url("../../assets/homePage/ptdw-shuj.png") center center no-repeat;
}
.PosiTion > .div .div5 {
  background: url("../../assets/homePage/ptdw-jinr.png") center center no-repeat;
}
/* 平台定位结束 */
/* 物润产融平台开始 */
.wrcrGylpt {
  height: 984px;
  background-color: #ffffff;
}
.wrcrGylpt > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.wrcrGylpt > .div {
  display: flex;
}

.wrcrGylpt > .div .div1,
.wrcrGylpt > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.wrcrGylpt > .div .div2 {
  margin: 30px 22px 0 22px;
  width: 1228px;
  height: 750px;
  background: url("../../assets/homePage/wrcr_gylpt.png") center center no-repeat;
}
/* 物润产融平台结束 */
/* 平台能力开始 */
.ability {
  height: 504px;
  color: #333333;
  background: #f5f7fa;
}
.ability > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 50px 0;
}
.ability > .div {
  display: flex;
  padding: 0 5%;
}

.ability > .div .div0 {
  flex: 1;
  padding: 0 20px;
}

.ability > .div .div0 .div1-1 {
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #373d41;
  line-height: 45px;
  margin-bottom: 30px;
}

.ability > .div .div0 .div1-1 img {
  width: 48px;
  height: 48px;
  vertical-align: middle;
}
.ability > .div .div0 .div1-2 {
  text-align: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 29px;
}
/* 平台能力结束 */

/* 行业实践开始 */
// .practice {
//   height: 504px;
//   color: #333333;
//   background: #ffffff;
// }
// .practice > .Title {
//   font-size: 35px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #000000;
//   text-align: center;
//   padding: 70px 0 50px 0;
// }
// .practice > .div {
//   display: flex;
//   /* padding: 0 5%; */
// }

// .practice > .div .div0 {
//   flex: 1;
//   padding: 0 20px;
//   margin: 0 17px;
// }
// .practice > .div .div2,
// .practice > .div .div3,
// .practice > .div .div4 {
//   padding-top: 30px;
//   width: 388px;
//   height: 224px;
//   background: #ffffff;
//   box-shadow: 0px 1px 36px 2px rgba(93, 93, 93, 0.13);
//   display: flex;
// }
// .practice > .div .div0 .div1-1 {
//   margin: auto;
//   text-align: center;
//   font-size: 24px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #373d41;
//   line-height: 45px;
//   display: flex;
// }
// .practice > .div .div0 .div1-1 div {
//   display: inline-block;
//   margin-left: -60px;
//   margin-top: -20px;
//   text-align: left;
// }
// .practice > .div .div0 .div1-1 div p:nth-child(1) {
//   font-size: 40px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #2f82ffff;
//   line-height: 81px;
// }

// .practice > .div .div0 .div1-1 div p:nth-child(2) {
//   font-size: 24px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #373d41;
//   line-height: 45px;
// }
// .practice > .div .div0 .div1-1 img {
//   width: 160px;
//   height: 135px;
//   vertical-align: middle;
// }
/* 行业实践结束 */
</style>
